import "/src/css/app.css";


/** Alpine JS */
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'

Alpine.plugin(intersect)
Alpine.plugin(collapse)

window.Alpine = Alpine

Alpine.start()


// Init Embla Carousel
import EmblaCarousel from 'embla-carousel'
import AutoScroll from 'embla-carousel-auto-scroll'
import Fade from 'embla-carousel-fade'
import Autoplay from 'embla-carousel-autoplay'


// Embla Logos Cycle
document.querySelectorAll('[data-embla-brand-logos]').forEach((emblaNode) => {
  const viewportNode = emblaNode.querySelector('.embla__viewport')
  const slideNodes = emblaNode.querySelectorAll('.embla__slide')

  if (!viewportNode || !slideNodes.length) return

  EmblaCarousel(
    viewportNode, {
      loop: true,
      align: 'center',
      startIndex: Math.floor(slideNodes.length / 2),
      dragFree: true,
      containScroll: false,
      watchDrag: false
    },
    [
      AutoScroll({
        speed: 0.5,
        direction: 'forward',
        startDelay: 0,
        stopOnInteraction: false,
        stopOnMouseEnter: false,
        stopOnFocusIn: false
      })
    ]
  )
})


// Embla Services Choices
document.querySelectorAll('[data-embla-services]').forEach((emblaNode) => {
  const viewportNode = emblaNode.querySelector('.embla__viewport')

  if (!viewportNode) return

  EmblaCarousel(
    viewportNode, {
      active: true,
      breakpoints: {
        '(min-width: 1280px)': {
          active: false
        }
      },
      loop: true,
      align: 'center',
      startIndex: 3,
      dragFree: false,
      containScroll: false
    }
  )
})


// Embla Fading Page Banners
document.querySelectorAll('[data-embla-banners]').forEach((emblaNode) => {
  const viewportNode = emblaNode.querySelector('.embla__viewport')

  if (!viewportNode) return
  
  EmblaCarousel(
    viewportNode,
    {
      loop: true,
      align: 'center',
      startIndex: 0,
      duration: 25,
      watchDrag: false
    },
    [
      Fade(),
      Autoplay({
        delay: 5000,
        stopOnInteraction: false,
        stopOnMouseEnter: false,
        stopOnFocusIn: false
      })
    ]
  )
})


// HMR - https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}